import { render, staticRenderFns } from "./DefectListCard.vue?vue&type=template&id=79951a08&scoped=true&"
import script from "./DefectListCard.vue?vue&type=script&lang=js&"
export * from "./DefectListCard.vue?vue&type=script&lang=js&"
import style0 from "./DefectListCard.vue?vue&type=style&index=0&id=79951a08&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79951a08",
  null
  
)

export default component.exports